<div
  class="bg-white d-flex flex-column align-items-start justify-content-start w-100 h-100 position-absolute"
  style="top:0;bottom:0;left:0;right:0;z-index:9000"
  >
  <div class="nav-item p-2 list-group-item justify-content-end cursor-pointer">
    <button
      class="btn btn-icon-light"
      (click)="onMobileSidenavToggle.emit()"
      >
      <svg-icon
        class="fill-current sidenav-icon"
        name="close"
      ></svg-icon>
    </button>
  </div>
  @if (scope) {
    <a
      class="nav-item p-2 list-group-item env-charts cursor-pointer"
      [routerLink]="['/', scope.id, 'charts']"
      routerLinkActive="bg-charts text-white"
      >
      <svg-icon
        class="fill-current sidenav-icon"
        name="chart"
      ></svg-icon>
      <span i18n>Charts</span>
    </a>
    @if ((watchesFeatureFlag$|async); as watchesFeatureFlag) {
      <a
        class="nav-item p-2 list-group-item env-watches cursor-pointer"
        [class.disabled]="!watchesFeatureFlag.isEnabled"
        [routerLink]="watchesFeatureFlag.isEnabled ? ['/', scope.id, 'watch-procedures'] : null"
        routerLinkActive="bg-watches text-white"
        >
        <svg-icon
          class="fill-current sidenav-icon"
          name="watch"
        ></svg-icon>
        <span i18n>Watches</span>
      </a>
    }
    @if ((reportsFeatureFlag$|async); as reportsFeatureFlag) {
      <a
        class="nav-item p-2 list-group-item env-reports"
        [class.disabled]="!reportsFeatureFlag.isEnabled"
        [routerLink]="reportsFeatureFlag.isEnabled ? ['/', scope.id, 'reporting-processes'] : null"
        routerLinkActive="bg-reports text-white"
        >
        <svg-icon
          class="fill-current sidenav-icon"
          name="report"
        ></svg-icon>
        <span i18n>Reports</span>
      </a>
    }
    @if ((readingsFeatureFlag$|async); as readingsFeatureFlag) {
      <a
        class="nav-item p-2 list-group-item env-readings cursor-pointer"
        [class.disabled]="!readingsFeatureFlag.isEnabled"
        [routerLink]="readingsFeatureFlag.isEnabled ? ['/', scope.id, 'reading-forms'] : null"
        routerLinkActive="bg-readings text-white"
        >
        <svg-icon
          class="fill-current sidenav-icon"
          name="pen"
        ></svg-icon>
        <span i18n>Manual readings</span>
      </a>
    }
    @if ((wasteFeatureFlag$|async)?.isEnabled) {
      <a
        class="nav-item p-2 list-group-item env-readings cursor-pointer"
        [routerLink]="['/', scope.id, 'waste']"
        routerLinkActive="bg-waste text-white"
        >
        <svg-icon
          class="sidenav-icon"
          name="waste"
        ></svg-icon>
        <span i18n>Waste</span>
      </a>
    }
  }
  <!-- USER ACCOUNT -->
  @if (showProfileLink$ | async) {
    <div
      class="nav-item p-2 list-group-item cursor-pointer"
      (click)="goToProfil()"
      >
      <svg-icon
        class="fill-current sidenav-icon cs-svg-icon-contained cs-svg-icon-centered"
        name="account"
        svgClass="h-100 w-100"
      ></svg-icon>
      <span i18n>My account</span>
    </div>
  }
  <!-- LANGUAGE -->
  @if (availableLanguages$ | async; as availableLanguages) {
    @if (availableLanguages.length > 1) {
      <div
        class="nav-item p-2 list-group-item cursor-pointer"
        ngbDropdown
        display="dynamic"
        >
        <svg-icon
          class="fill-current sidenav-icon"
          name=""
        ></svg-icon>
        <span
          ngbDropdownToggle
          class="me-2 d-flex align-items-center cursor-pointer"
          i18n
        >Languages ({{ currentLocale$ | async | uppercase }})</span>
        <div
          ngbDropdownMenu
          class="sidenav-dropdown-menu dropdown-menu-left shadow-sm border-0 p-0"
          style="margin-top: 18px; border-radius:  0; min-width: 25px;"
          >
          <div class="list-group">
            @for (lang of availableLanguages; track lang) {
              <a
                (click)="selectLanguage(lang)"
                class="dropdown-item list-group-item cursor-pointer border-start-0 border-end-0"
                >
                <div style="font-weight: 500">{{lang | uppercase}}</div>
              </a>
            }
          </div>
        </div>
      </div>
    }
  }
  <!-- LOGOUT -->
  <div
    class="nav-item p-2 list-group-item cursor-pointer"
    (click)="logout()"
    >
    <svg-icon
      class="fill-current sidenav-icon cs-svg-icon-contained cs-svg-icon-centered"
      name="logout"
      svgClass="h-100 w-100"
    ></svg-icon>
    <span i18n>Log out</span>
  </div>
</div>